import React from "react";
import { observer } from "mobx-react";
import Search from "../Icons/Search.svg";
import Reset from "../Icons/Reset.svg";

const Header = observer(
  ({
    pendingSearch,
    updatePendingSearch,
    search,
    updateSearch,
    daysAgo,
    daysAgoOptions,
    updateDaysAgo,
    mode,
    changePlaylistMode,
  }) => {
    const adjustedDaysAgoOptions = [
      ...new Set([...daysAgoOptions, daysAgo]),
    ].sort((a, b) => a - b);

    // Handle search input changes - update both pending and actual search
    const handleSearchChange = (value) => {
      updatePendingSearch(value);
      // Update search immediately to filter feeds in real-time
      updateSearch(value);
    };

    // Handle reset button click
    const handleResetClick = () => {
      updatePendingSearch("");
      updateSearch("");
    };

    return (
      <div className="article-search" style={{ position: 'fixed', top: 0, width: '100%', zIndex: 1000 }}>
        {mode === "discover" ? (
          <>
            <div className="header">
              {search.trim().length === 0 ? "Feeds" : "Search"}
            </div>
            {/* <div className="days-ago">
              {search.length === 0 ? (
                <select
                  value={daysAgo}
                  onChange={({ target: { value } }) =>
                    updateDaysAgo(parseInt(value, 10))
                  }
                >
                  {adjustedDaysAgoOptions.map((option) => (
                    <option key={option} value={option}>
                      Last {option} days
                    </option>
                  ))}
                </select>
              ) : null}
            </div> */}
            <div className="search" style={{ marginRight: '300px', marginLeft: 'auto' }}>
              <img src={Search} />
              <input
                type="text"
                placeholder="Search feeds..."
                value={pendingSearch}
                className="placeholder"
                onChange={({ target: { value } }) => handleSearchChange(value)}
              />
              {pendingSearch.trim().length > 0 ? (
                <img src={Reset} onClick={handleResetClick} />
              ) : null}
            </div>
          </>
        ) : (
          <>
            <div className="header">Playlist</div>
            <div className="days-ago">
              <select
                onChange={({ target: { value } }) => changePlaylistMode(value)}
              >
                <option key="all" value="all">
                  Show All Articles
                </option>
                <option key="unplayed" value="unplayed">
                  Show Unplayed Articles
                </option>
                <option key="played" value="played">
                  Show Played Articles
                </option>
              </select>
            </div>
            <div className="search"></div>
          </>
        )}
      </div>
    );
  }
);

export default Header;
